import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './careers-search-component.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var CareersSearchComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareersSearchComponent, _super);
    function CareersSearchComponent(element) {
        return _super.call(this, element) || this;
    }
    CareersSearchComponent.prototype.init = function () {
        var _this = this;
        this.attributeSite = this.element.getAttribute('data-site');
        this.attributeDetail = this.element.getAttribute('data-detail-url');
        this.attributeLanguage = "en-us";
        this.attributeCountry = "";
        this.attributeDepartment = "";
        this.attributeRegion = "";
        this.attributeType = "";
        this.attributeArrangement = "";
        if (this.element.getAttribute('data-limit')) {
            this.attributeLimit = this.element.getAttribute('data-limit');
        }
        else {
            this.attributeLimit = 10;
        }
        this.buttonAdvancedFilters = Array.from(this.element.querySelectorAll('.js-show-advanced'));
        this.buttonSearch = Array.from(this.element.querySelectorAll('.filter-builder__form-field--searchbutton'));
        this.buttonSearchClear = Array.from(this.element.querySelectorAll('.filter-builder__form-field--searchbuttonclear'));
        this.buttonEmptyReset = Array.from(this.element.querySelectorAll('.js-empty-reset'));
        this.buttonPaginationItems = Array.from(this.element.querySelectorAll('.pagination__item'));
        this.buttonPaginationPrevious = this.element.querySelector('.pagination__nav--prev');
        this.buttonPaginationNext = this.element.querySelector('.pagination__nav--next');
        this.buttonApplyFilters = Array.from(this.element.querySelectorAll('.js-clear-filters'));
        this.formFieldSearchBar = Array.from(this.element.querySelectorAll('.js-form-search-bar'));
        this.formFieldCountries = Array.from(this.element.querySelectorAll('.js-form-countries-top'));
        this.formFieldLanguage = Array.from(this.element.querySelectorAll('.js-form-language'));
        this.formFieldCountriesLoader = this.element.querySelector('.js-form-country-loader');
        this.formFieldDepartments = Array.from(this.element.querySelectorAll('.js-form-departments'));
        this.formFieldArrangements = Array.from(this.element.querySelectorAll('.js-form-arrangements'));
        this.formFieldRegions = Array.from(this.element.querySelectorAll('.js-form-regions-advanced'));
        this.formFieldLocations = Array.from(this.element.querySelectorAll('.js-form-regions-location'));
        this.containerLanguage = Array.from(this.element.querySelectorAll('.careers-search-component__language'));
        this.containerResults = this.element.querySelector('.js-results-search');
        this.containerEmptyResults = Array.from(this.element.querySelectorAll('.js-empty-results'));
        this.containerPagination = this.element.querySelector('.careers-component__pagination');
        this.varEmploymentCheckboxContainer = Array.from(this.element.querySelectorAll('.js-form-employment-container'));
        this.varAdvancedFields = Array.from(this.element.querySelectorAll('.js-advanced-filters'));
        this.varAdvancedShowHide = false;
        this.varLoader = this.element.querySelector('.js-results-search-loader');
        this.varPaginationIndex = 0;
        this.varFormStarted = false;
        this.varInitCountries = false;
        this.varTranslationAll = "All";
        this.varTranslationDept = "Career Area";
        this.varTranslationJobType = "Job Type";
        this.varTranslationDatePosted = "Date Posted";
        this.urlCountries = "/sbutils/getCountries?";
        this.urlTypes = "/sbutils/getEmploymentTypes?";
        this.urlDepartments = "/sbutils/getSectors?";
        this.urlArrangements = "/sbutils/getWorkArrangement?";
        this.urlProvince = "/sbutils/getRegions?";
        this.urlLocation = "/sbutils/getLocations?";
        this.urlJobs = "/sbutils/getJobs?";
        // this.httpGetSite();
        this.hideRegionsAndLocations();
        this.httpGetCountries(100);
        this.httpEmploymentTypes(100);
        this.httpDepartments(100);
        this.httpArrangements(100);
        this.httpGetJobs(this.attributeLimit);
        $(document).on('change', 'select.js-form-countries-top', function (e) {
            var target = e.target;
            var value = target.value;
            _this.attributeCountry = value;
            _this.attributeRegion = "";
            _this.attributeLocation = "";
            _this.varPaginationIndex = 0;
            $('select.js-form-countries-top').each(function (index, item) {
                $(item).val(value);
            });
            if (value !== "") {
                _this.hideRegionsAndLocations(true, false);
                _this.httpRegions(100);
            }
            else {
                _this.hideRegionsAndLocations();
            }
            if (target.classList.contains('js-form-countries-top-redirect')) {
                _this.httpGetJobs(_this.attributeLimit);
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
        });
        $(document).on('change', 'select.js-form-departments', function (e) {
            var target = e.target;
            var value = target.value;
            _this.attributeDepartment = value;
        });
        $(document).on('change', 'select.js-form-arrangements', function (e) {
            var target = e.target;
            var value = target.value;
            _this.attributeArrangement = value;
        });
        $(document).on('change', 'select.js-form-regions-advanced', function (e) {
            var target = e.target;
            var value = target.value;
            _this.attributeRegion = value;
            _this.attributeLocation = "";
            if (value !== "") {
                _this.hideRegionsAndLocations(true, true);
                _this.httpLocations(100);
            }
            else {
                _this.hideRegionsAndLocations(true, false);
            }
        });
        $(document).on('change', 'select.js-form-regions-location', function (e) {
            var target = e.target;
            var value = target.value;
            _this.attributeLocation = value;
        });
        $(document).on('click', 'input.js-form-employment-type', function (e) {
            var types = "";
            $('input.js-form-employment-type').each(function (index, item) {
                if ($(item).is(':checked')) {
                    if (types === "") {
                        types += $(item).val();
                    }
                    else {
                        types += "," + $(item).val();
                    }
                }
            });
            _this.attributeType = types;
            _this.varPaginationIndex = 0;
            _this.httpGetJobs(_this.attributeLimit);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
        $(document).on('click', 'li.pagination__item', function (e) {
            var target = e.target;
            var page = target.getAttribute('data-page');
            var limit = target.getAttribute('data-limit');
            var offset = parseInt(page) * parseInt(limit);
            _this.varPaginationIndex = page;
            _this.httpGetJobs(limit, offset);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
        $("form#filter-builder-form").submit(function (e) {
            e.preventDefault();
            _this.varPaginationIndex = 0;
            if (!_this.varFormStarted) {
                _this.varFormStarted = true;
                _this.analyticsFormComplete();
            }
            _this.httpGetJobs(_this.attributeLimit, 0);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
        $("form#careers_search_form").submit(function (e) {
            e.preventDefault();
            _this.varPaginationIndex = 0;
            if (!_this.varFormStarted) {
                _this.varFormStarted = true;
                _this.analyticsFormComplete();
            }
            _this.httpGetJobs(_this.attributeLimit, 0);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
    };
    CareersSearchComponent.prototype.bindEvents = function () {
        var _this = this;
        this.buttonSearch.map(function (button) { return button.addEventListener('click', function (e) {
            _this.varPaginationIndex = 0;
            if (!_this.varFormStarted) {
                _this.varFormStarted = true;
                _this.analyticsFormComplete();
            }
            _this.httpGetJobs(_this.attributeLimit, 0);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        }); });
        this.buttonSearchClear.map(function (button) { return button.addEventListener('click', function (e) {
            _this.formFieldSearchBar.map(function (item) {
                item.value = "";
            });
            _this.attributeKeyword = "";
            // this.varPaginationIndex = 0;
            // this.httpGetJobs(this.attributeLimit);
            // $('html,body').animate({ 
            // 	scrollTop: 0
            // }, 'slow');
        }); });
        this.buttonEmptyReset.map(function (button) { return button.addEventListener('click', function (e) {
            _this.attributeLanguage = "en-us";
            _this.attributeCountry = "";
            _this.attributeDepartment = "";
            _this.attributeRegion = "";
            _this.attributeLocation = "";
            _this.attributeType = "";
            _this.attributeArrangement = "";
            _this.attributeKeyword = "";
            _this.hideRegionsAndLocations(false, false);
            $("form#filter-builder-form").trigger("reset");
            _this.httpGetCountries(100);
            _this.varPaginationIndex = 0;
            _this.httpGetJobs(_this.attributeLimit);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        }); });
        this.formFieldSearchBar.map(function (item) { return item.addEventListener('keyup', function (e) {
            _this.attributeKeyword = e.target.value;
            _this.formFieldSearchBar.map(function (item) {
                item.value = e.target.value;
            });
        }); });
        this.formFieldLanguage.map(function (item) { return item.addEventListener('change', function (e) {
            _this.varAdvancedShowHide = true;
            _this.showHideAdvanced();
            _this.attributeLanguage = e.target.value;
            _this.attributeCountry = "";
            _this.showLanguage(e.target.value);
            _this.formFieldLanguage.map(function (item) {
                item.value = e.target.value;
            });
            if (e.target.value === "pt") {
                _this.varTranslationAll = "Todos";
                _this.varTranslationDept = "Área de Carreira";
                _this.varTranslationJobType = "Tipo de emprego";
                _this.varTranslationDatePosted = "Data de publicação";
            }
            else {
                _this.varTranslationAll = "All";
                _this.varTranslationDept = "Career Area";
                _this.varTranslationJobType = "Job Type";
                _this.varTranslationDatePosted = "Date Posted";
            }
            _this.httpGetCountries(100);
            _this.httpEmploymentTypes(100);
            _this.httpDepartments(100);
            _this.httpArrangements(100);
            _this.varPaginationIndex = 0;
            _this.httpGetJobs(_this.attributeLimit);
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        }); });
        this.buttonAdvancedFilters.map(function (button) { return button.addEventListener('click', function (e) {
            _this.showHideAdvanced();
        }); });
        this.buttonApplyFilters.map(function (button) { return button.addEventListener('click', function (e) {
            var element = e.target;
            _this.varPaginationIndex = 0;
            if (element.classList.contains('button--main')) {
                _this.httpGetJobs(_this.attributeLimit);
            }
            else {
                _this.attributeLanguage = "en-us";
                _this.attributeCountry = "";
                _this.attributeDepartment = "";
                _this.attributeRegion = "";
                _this.attributeLocation = "";
                _this.attributeType = "";
                _this.attributeArrangement = "";
                _this.attributeKeyword = "";
                _this.hideRegionsAndLocations(false, false);
                $("form#careers_search_form").trigger("reset");
                _this.httpGetCountries(100);
                _this.httpGetJobs(_this.attributeLimit);
            }
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        }); });
        this.buttonPaginationPrevious.addEventListener('click', function (e) {
            if (!_this.buttonPaginationPrevious.classList.contains('pagination__nav--disabled')) {
                _this.varPaginationIndex = _this.varPaginationIndex - 1;
                var offset = parseInt(_this.varPaginationIndex) * _this.attributeLimit;
                _this.httpGetJobs(_this.attributeLimit, offset);
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
        });
        this.buttonPaginationNext.addEventListener('click', function (e) {
            if (!_this.buttonPaginationNext.classList.contains('pagination__nav--disabled')) {
                _this.varPaginationIndex = _this.varPaginationIndex + 1;
                var offset = parseInt(_this.varPaginationIndex) * _this.attributeLimit;
                _this.httpGetJobs(_this.attributeLimit, offset);
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
        });
    };
    CareersSearchComponent.prototype.showLanguage = function (language) {
        this.containerLanguage.map(function (container) {
            container.classList.add('d-none');
            var attribute = container.getAttribute('data-language');
            if (attribute === language) {
                container.classList.remove('d-none');
            }
        });
    };
    CareersSearchComponent.prototype.showHideAdvanced = function () {
        if (this.varAdvancedShowHide) {
            this.varAdvancedFields.map(function (item) {
                item.classList.add('d-none');
            });
            this.varAdvancedShowHide = false;
        }
        else {
            this.varAdvancedFields.map(function (item) {
                item.classList.remove('d-none');
            });
            this.varAdvancedShowHide = true;
        }
    };
    CareersSearchComponent.prototype.hideRegionsAndLocations = function (showRegions, showLocations) {
        if (showRegions === void 0) { showRegions = false; }
        if (showLocations === void 0) { showLocations = false; }
        if (showRegions) {
            this.formFieldRegions.map(function (container) {
                var containerRegions = container.closest('.js-advanced-filters');
                containerRegions.classList.remove('careers-search-component__location--hidden');
            });
        }
        else {
            this.formFieldRegions.map(function (container) {
                var containerRegions = container.closest('.js-advanced-filters');
                containerRegions.classList.add('careers-search-component__location--hidden');
            });
        }
        if (showLocations) {
            this.formFieldLocations.map(function (container) {
                var containerLocations = container.closest('.js-advanced-filters');
                containerLocations.classList.remove('careers-search-component__location--hidden');
            });
        }
        else {
            this.formFieldLocations.map(function (container) {
                var containerLocations = container.closest('.js-advanced-filters');
                containerLocations.classList.add('careers-search-component__location--hidden');
            });
        }
    };
    /////////////////////////////////////
    /////////////////////////////////////
    //// HTTP
    /////////////////////////////////////
    /////////////////////////////////////
    CareersSearchComponent.prototype.httpGetCountries = function (limit) {
        if (limit === void 0) { limit = 100; }
        // generate
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var formField = this.formFieldCountries;
        var varTranslationAll = this.varTranslationAll;
        var generateCountries = this.generateCountries;
        formField.map(function (field) {
            field.innerHTML = "";
            var option = document.createElement('option');
            option.text = varTranslationAll;
            option.value = "";
            field.appendChild(option);
        });
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=0';
        // variables
        var urlGeneric = this.urlCountries + postData;
        var url = this.urlCountries;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var calculate = parseInt(json.total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            for (var index = 0; index < times; index++) {
                generateCountries(url, site, limit, (limit * index), language, formField);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.httpEmploymentTypes = function (limit) {
        if (limit === void 0) { limit = 100; }
        // generate
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var formField = this.varEmploymentCheckboxContainer;
        var generateEmploymentTypes = this.generateEmploymentTypes;
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        // variables
        var urlGeneric = this.urlTypes + postData;
        var url = this.urlTypes;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var calculate = parseInt(json.total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            for (var index = 0; index < times; index++) {
                generateEmploymentTypes(url, site, limit, (limit * index), language, formField);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.httpDepartments = function (limit) {
        if (limit === void 0) { limit = 100; }
        // generate
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var formField = this.formFieldDepartments;
        var varTranslationAll = this.varTranslationAll;
        var generateDepartments = this.generateDepartments;
        var generateDepartmentsNew = this.generateDepartmentsNew;
        formField.map(function (field) {
            field.innerHTML = "";
            var option = document.createElement('option');
            option.text = varTranslationAll;
            option.value = "";
            field.appendChild(option);
        });
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=0';
        // variables
        var urlGeneric = this.urlDepartments + postData;
        var url = this.urlDepartments;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var calculate = parseInt(json.total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            // create axios array
            var axiosArray = [];
            for (var index = 0; index < times; index++) {
                var postDataNew = "site=" + site + "&locale=" + language + "&limit=" + limit + "&offset=" + (limit * index);
                var urlNew = url + postDataNew;
                var request = axios.get(urlNew);
                axiosArray.push(request);
            }
            // check array and ruyn commands
            if (axiosArray.length > 0) {
                axios.all(axiosArray).then(axios.spread(function () {
                    var responses = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        responses[_i] = arguments[_i];
                    }
                    for (var index = 0; index < responses.length; index++) {
                        var data = responses[index].data;
                        if (data.results.length > 0) {
                            generateDepartmentsNew(data.results, formField);
                        }
                    }
                })).catch(function (errors) {
                    console.log(errors);
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.httpArrangements = function (limit) {
        if (limit === void 0) { limit = 100; }
        // generate
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var formField = this.formFieldArrangements;
        var varTranslationAll = this.varTranslationAll;
        var generateArrangements = this.generateArrangements;
        formField.map(function (field) {
            field.innerHTML = "";
            var option = document.createElement('option');
            option.text = varTranslationAll;
            option.value = "";
            field.appendChild(option);
        });
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=0';
        // variables
        var urlGeneric = this.urlArrangements + postData;
        var url = this.urlArrangements;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var calculate = parseInt(json.total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            for (var index = 0; index < times; index++) {
                generateArrangements(url, site, limit, (limit * index), language, formField);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.httpRegions = function (limit) {
        if (limit === void 0) { limit = 100; }
        // generate
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var country = this.attributeCountry;
        var formField = this.formFieldRegions;
        var varTranslationAll = this.varTranslationAll;
        var generateRegions = this.generateRegions;
        formField.map(function (field) {
            field.innerHTML = "";
            var option = document.createElement('option');
            option.text = varTranslationAll;
            option.value = "";
            field.appendChild(option);
        });
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (site) {
            postData += '&countryCode=' + country;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=0';
        // variables
        var urlGeneric = this.urlProvince + postData;
        var url = this.urlProvince;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var calculate = parseInt(json.total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            for (var index = 0; index < times; index++) {
                generateRegions(url, site, country, limit, (limit * index), language, formField);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.httpLocations = function (limit) {
        if (limit === void 0) { limit = 100; }
        // generate
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var region = this.attributeRegion;
        var formField = this.formFieldLocations;
        var varTranslationAll = this.varTranslationAll;
        var generateLocations = this.generateLocations;
        var generateLocationsNew = this.generateLocationsNew;
        formField.map(function (field) {
            field.innerHTML = "";
            var option = document.createElement('option');
            option.text = varTranslationAll;
            option.value = "";
            field.appendChild(option);
        });
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (region) {
            postData += '&regionCode=' + region;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=0';
        // variables
        var urlGeneric = this.urlLocation + postData;
        var url = this.urlLocation;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var calculate = parseInt(json.total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            // create axios array
            var axiosArray = [];
            for (var index = 0; index < times; index++) {
                var postDataNew = "site=" + site + "&regionCode=" + region + "&locale=" + language + "&limit=" + limit + "&offset=" + (limit * index);
                var urlNew = url + postDataNew;
                var request = axios.get(urlNew);
                axiosArray.push(request);
            }
            // check array and ruyn commands
            if (axiosArray.length > 0) {
                axios.all(axiosArray).then(axios.spread(function () {
                    var responses = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        responses[_i] = arguments[_i];
                    }
                    for (var index = 0; index < responses.length; index++) {
                        var data = responses[index].data;
                        if (data.results.length > 0) {
                            generateLocationsNew(data.results, formField);
                        }
                    }
                })).catch(function (errors) {
                    console.log(errors);
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.httpGetJobs = function (limit, offset) {
        if (limit === void 0) { limit = 10; }
        if (offset === void 0) { offset = 0; }
        // attributes
        var site = this.attributeSite;
        var language = this.attributeLanguage;
        var location = this.attributeLocation;
        var type = this.attributeType;
        var keyword = this.attributeKeyword;
        var category = this.attributeDepartment;
        var arrangement = this.attributeArrangement;
        var country = this.attributeCountry;
        var region = this.attributeRegion;
        // translations
        var varTranslationDept = this.varTranslationDept;
        var varTranslationJobType = this.varTranslationJobType;
        var varTranslationDatePosted = this.varTranslationDatePosted;
        var attributeDetail = this.attributeDetail;
        var containerResults = this.containerResults;
        var containerEmptyResults = this.containerEmptyResults;
        var containerPagination = this.containerPagination;
        var generatePagination = this.generatePagination;
        var analyticsSiteSearch = this.analyticsSiteSearch;
        var analyticsError = this.analyticsError;
        // let analyticsError: any = this.analyticsError;
        var varPaginationIndex = this.varPaginationIndex;
        var buttonPaginationPrevious = this.buttonPaginationPrevious;
        var buttonPaginationNext = this.buttonPaginationNext;
        containerPagination.classList.add('d-none');
        containerEmptyResults.map(function (container) {
            container.classList.add('d-none');
        });
        // analyrtics
        var varLoader = this.varLoader;
        containerResults.classList.add('d-none');
        varLoader.classList.remove('d-none');
        containerResults.innerHTML = "";
        var analyticsFilter = '';
        var analyticsTerm = '';
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (language) {
            postData += '&locale=' + language;
            analyticsFilter += 'locale=' + language;
        }
        if (type) {
            postData += '&empType=' + type;
            analyticsFilter += ',employmentType=' + type;
        }
        if (keyword) {
            postData += '&keyWord=' + keyword;
            analyticsTerm += keyword;
        }
        if (category) {
            postData += '&category=' + category;
            analyticsFilter += ',department=' + type;
        }
        if (arrangement) {
            postData += '&workArrangement=' + arrangement;
            analyticsFilter += ',workArrangement=' + type;
        }
        if (country) {
            postData += '&country=' + country;
            analyticsFilter += ',country=' + country;
        }
        if (region) {
            postData += '&province=' + region;
            analyticsFilter += ',region=' + region;
        }
        if (location) {
            postData += '&location=' + location;
            analyticsFilter += ',location=' + location;
        }
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // date
        var todaysDate = new Date();
        var fullDate = todaysDate.getFullYear().toString() + todaysDate.getMonth().toString() + todaysDate.getDate().toString() + todaysDate.getHours().toString() + todaysDate.getMinutes().toString();
        postData += "&time=" + fullDate;
        // variables
        var urlGeneric = this.urlJobs + postData;
        var url = this.urlJobs;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var results = json.results;
            var output = "";
            if (json.total === 0) {
                varLoader.classList.add('d-none');
                containerEmptyResults.map(function (container) {
                    container.classList.remove('d-none');
                });
            }
            else {
                results.map(function (job) {
                    var date = new Date(job.datePosted).toLocaleDateString();
                    output += "<div class=\"careers-search-component__result\">\n\t\t\t\t\t\t<div class=\"careers-search-component__result--title\">\n\t\t\t\t\t\t\t<a href=\"" + attributeDetail + "?jobID=" + job.jobPostId + "&jobSite=" + site + "&jobLocale=" + job.locale + "\" target=\"_blank\" class=\"title title--module-title\" data-intent=\"navigational\" data-scope=\"careers-search-component\" data-id=\"link_content\" data-text=\"Job Search | Results | " + job.title + " item click\">" + job.title + "</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"careers-search-component__result--details\">\n\t\t\t\t\t\t\t<div class=\"careers-search-component__result--details__location\">\n\t\t\t\t\t\t\t\t<strong>" + job.jobLocation[0].name + "</strong>\n\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t<div class=\"careers-search-component__result--details__meta\">\n\t\t\t\t\t\t\t\t<div class=\"careers-search-component__result--details__meta--dept\">\n\t\t\t\t\t\t\t\t\t<strong>" + varTranslationDept + "</strong>: " + job.FLD_JPM_BUSINESS_LINE + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"careers-search-component__result--details__meta--type\">\n\t\t\t\t\t\t\t\t\t<strong>" + varTranslationJobType + "</strong>: " + job.employmentType + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"careers-search-component__result--description\">\n\t\t\t\t\t\t\t" + job.description + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
                });
                generatePagination(containerPagination, limit, json.total, varPaginationIndex, buttonPaginationPrevious, buttonPaginationNext);
                varLoader.classList.add('d-none');
                containerResults.innerHTML = output;
                containerResults.classList.remove('d-none');
            }
            analyticsSiteSearch(json.total, analyticsFilter, analyticsTerm);
        }).catch(function (error) {
            varLoader.classList.add('d-none');
            containerEmptyResults.map(function (container) {
                container.classList.remove('d-none');
            });
            // analytics
            analyticsError('service down', '500');
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////
    //// GENERATE
    /////////////////////////////////////
    /////////////////////////////////////
    CareersSearchComponent.prototype.generateCountries = function (urlName, site, limit, offset, language, formField) {
        if (urlName === void 0) { urlName = ""; }
        if (site === void 0) { site = "EXTERNAL"; }
        if (limit === void 0) { limit = 100; }
        if (offset === void 0) { offset = 0; }
        if (language === void 0) { language = ""; }
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var url = urlName + postData;
        // service
        return axios.get(url).then(function (response) {
            var json = response.data;
            var results = json.results;
            formField.map(function (field) {
                results.map(function (country) {
                    var option = document.createElement('option');
                    option.text = country.display;
                    option.value = country.code;
                    field.appendChild(option);
                });
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.generateEmploymentTypes = function (urlName, site, limit, offset, language, formField) {
        if (urlName === void 0) { urlName = ""; }
        if (site === void 0) { site = "EXTERNAL"; }
        if (limit === void 0) { limit = 100; }
        if (offset === void 0) { offset = 0; }
        if (language === void 0) { language = ""; }
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        // variables
        var url = urlName + postData;
        // service
        axios.get(url).then(function (response) {
            var json = response.data;
            var results = json.results;
            var output = "";
            var outputMobile = "";
            results.map(function (type) {
                output += "<label class=\"form__label filter-builder__form-field--checkboxlabel\">\n\t\t\t\t\t<div class=\"form__control\">\n\t\t\t\t\t\t<span class=\"form__control--checkbox-title\">" + type.display + "</span>\n\t\t\t\t\t\t<div class=\"form__control--checkbox\">\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"form__input js-form-employment-type\" data-value=\"" + type.code + "\" value=\"" + type.code + "\">\n\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</label>";
                outputMobile += "<div class=\"filter-builder__form-field--select-box-item filter-builder__form-field--select-box-item__nohover\" data-name=\"" + type.display + "\" data-value=\"" + type.code + "\">\n\t\t\t\t\t<label class=\"form__label filter-builder__form-field--checkboxlabel\">\n\t\t\t\t\t\t<div class=\"form__control\">\n\t\t\t\t\t\t\t<span class=\"form__control--checkbox-title\">" + type.display + "</span>\n\t\t\t\t\t\t\t<div class=\"form__control--checkbox\">\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"form__input js-form-employment-type\" data-value=\"" + type.code + "\" value=\"" + type.code + "\">\n\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</label>\n\t\t\t\t</div>";
            });
            formField.map(function (item) {
                var container = item.querySelector('.filter-builder__form-field--container');
                var containerMobile = item.querySelector('.filter-builder__form-field--select-box');
                container.innerHTML = output;
                containerMobile.innerHTML = outputMobile;
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.generateDepartments = function (urlName, site, limit, offset, language, formField) {
        if (urlName === void 0) { urlName = ""; }
        if (site === void 0) { site = "EXTERNAL"; }
        if (limit === void 0) { limit = 100; }
        if (offset === void 0) { offset = 0; }
        if (language === void 0) { language = ""; }
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var url = urlName + postData;
        // service
        axios.get(url).then(function (response) {
            var json = response.data;
            var results = json.results;
            formField.map(function (field) {
                results.map(function (country) {
                    var option = document.createElement('option');
                    option.text = country.display;
                    option.value = country.code;
                    field.appendChild(option);
                });
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.generateDepartmentsNew = function (results, formField) {
        if (results === void 0) { results = []; }
        if (formField === void 0) { formField = undefined; }
        formField.map(function (field) {
            results.map(function (department) {
                var option = document.createElement('option');
                option.text = department.display;
                option.value = department.code;
                field.appendChild(option);
            });
        });
    };
    CareersSearchComponent.prototype.generateArrangements = function (urlName, site, limit, offset, language, formField) {
        if (urlName === void 0) { urlName = ""; }
        if (site === void 0) { site = "EXTERNAL"; }
        if (limit === void 0) { limit = 100; }
        if (offset === void 0) { offset = 0; }
        if (language === void 0) { language = ""; }
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var url = urlName + postData;
        // service
        axios.get(url).then(function (response) {
            var json = response.data;
            var results = json.results;
            formField.map(function (field) {
                results.map(function (country) {
                    var option = document.createElement('option');
                    option.text = country.display;
                    option.value = country.code;
                    field.appendChild(option);
                });
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.generateRegions = function (urlName, site, country, limit, offset, language, formField) {
        if (urlName === void 0) { urlName = ""; }
        if (site === void 0) { site = "EXTERNAL"; }
        if (country === void 0) { country = "ZAF"; }
        if (limit === void 0) { limit = 100; }
        if (offset === void 0) { offset = 0; }
        if (language === void 0) { language = ""; }
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (country) {
            postData += '&countryCode=' + country;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var url = urlName + postData;
        // service
        axios.get(url).then(function (response) {
            var json = response.data;
            var results = json.results;
            formField.map(function (field) {
                results.map(function (country) {
                    var option = document.createElement('option');
                    option.text = country.display;
                    option.value = country.code;
                    field.appendChild(option);
                });
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.generateLocations = function (urlName, site, region, limit, offset, language, formField) {
        if (urlName === void 0) { urlName = ""; }
        if (site === void 0) { site = "EXTERNAL"; }
        if (region === void 0) { region = "Eastern Cape"; }
        if (limit === void 0) { limit = 100; }
        if (offset === void 0) { offset = 0; }
        if (language === void 0) { language = ""; }
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (region) {
            postData += '&regionCode=' + region;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var url = urlName + postData;
        // service
        axios.get(url).then(function (response) {
            var json = response.data;
            var results = json.results;
            formField.map(function (field) {
                results.map(function (country) {
                    var option = document.createElement('option');
                    option.text = country.display;
                    option.value = country.code;
                    field.appendChild(option);
                });
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersSearchComponent.prototype.generateLocationsNew = function (results, formField) {
        if (results === void 0) { results = []; }
        return new Promise(function (resolve, reject) {
            formField.map(function (field) {
                results.map(function (location) {
                    var option = document.createElement('option');
                    option.text = location.display;
                    option.value = location.code;
                    field.appendChild(option);
                });
            });
        });
    };
    CareersSearchComponent.prototype.generatePagination = function (container, limit, total, paginationIndex, paginationControlPrev, paginationControlNext) {
        if (container === void 0) { container = ""; }
        if (limit === void 0) { limit = 10; }
        if (total === void 0) { total = 0; }
        if (paginationIndex === void 0) { paginationIndex = 0; }
        if (paginationControlPrev === void 0) { paginationControlPrev = ""; }
        if (paginationControlNext === void 0) { paginationControlNext = ""; }
        container.classList.remove('d-none');
        var pagination = container.querySelector('.pagination__items');
        var calculate = parseInt(total) / parseInt(limit);
        var times = 0;
        if (calculate.toString().indexOf('.') > -1) {
            var number = parseInt(calculate.toString().split(".")[0]);
            times = number + 1;
        }
        else {
            times = calculate;
        }
        var output = "";
        for (var index = 0; index < times; index++) {
            if (paginationIndex === 0) {
                paginationControlPrev.classList.add('pagination__nav--disabled');
                paginationControlNext.classList.remove('pagination__nav--disabled');
                if (index === 0) {
                    output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === 1) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === 2) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
            }
            else if (paginationIndex === (times - 1)) {
                paginationControlPrev.classList.remove('pagination__nav--disabled');
                paginationControlNext.classList.add('pagination__nav--disabled');
                if (index === times) {
                    output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === (times - 1)) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === (times - 2)) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
            }
            else {
                paginationControlPrev.classList.remove('pagination__nav--disabled');
                paginationControlNext.classList.remove('pagination__nav--disabled');
                var getPrevious = parseInt(paginationIndex) - 1;
                var getCurrent = parseInt(paginationIndex);
                var getNext = parseInt(paginationIndex) + 1;
                if (index === getPrevious) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === getCurrent) {
                    output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else if (index === getNext) {
                    output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
                else {
                    output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                }
            }
        }
        pagination.innerHTML = output;
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// ANALYTICS
    /////////////////////////////////////
    /////////////////////////////////////	
    CareersSearchComponent.prototype.analyticsSiteSearch = function (total, filter, term) {
        if (total === void 0) { total = 0; }
        if (filter === void 0) { filter = ''; }
        if (term === void 0) { term = ''; }
        // analytics
        dataLayer.search.filter = filter;
        dataLayer.numSearchResults = total;
        dataLayer.searchTerm = term;
        _satellite.track('searchButtonSubmit');
    };
    CareersSearchComponent.prototype.analyticsFormStart = function () {
        // analytics form started
        if (!this.varFormStarted) {
            dataLayer.formStatus = '';
            dataLayer.formisSubmitted = 'false';
            _satellite.track('globalFormStart');
            this.varFormStarted = true;
        }
    };
    CareersSearchComponent.prototype.analyticsFormComplete = function () {
        // analytics
        dataLayer.formStatus = 'complete';
        dataLayer.formisSubmitted = 'true';
        _satellite.track('globalFormComplete');
    };
    CareersSearchComponent.prototype.analyticsError = function (message, code) {
        if (message === void 0) { message = 'service down'; }
        if (code === void 0) { code = '500'; }
        // analytics form
        dataLayer.siteErrorCode = code + ' | ' + message;
        _satellite.track('sendSiteErrorCode');
    };
    return CareersSearchComponent;
}(Base));
export { CareersSearchComponent };



//////////////////
// WEBPACK FOOTER
// ./components/careers-search-component/careers-search-component.component.ts
// module id = 617
// module chunks = 0